
const getters = {
  // 设备数据
  header: state => state.device,
  lang: state => state.device.lang,
  platform: state => state.device.platform,
  appVersion: state => state.device.appVersion,
  // 用户登录令牌
  token: state => state.user.token,
  // 选择的企业前缀
  selectOrgId: state => state.user.selectOrgId
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js